export interface ApplyWfh {
  leave_type: string;
  /** 1 = full day, 2 = half day (same semantics as apply leave range vs time-based) */
  wfh_type: string;
  from_date: Date | string;
  to_date: Date | string;
  start_time: string;
  end_time: string;
  leave_purpose: string;
  leave_description: string;
  wfh_status: string;
  wfh_id?: string;
  leave_purpose_other?: string;
}

export interface WfhRequestDetail {
  wfh_id: string,
  lev_type: string,
  wfh_purpose: string,
  wfh_start_date: Date | string,
  wfh_end_date: Date | string,
  /** 1 = full day, 2 = half day */
  wfh_type?: string | number | null;
  wfh_start_time?: string | null;
  wfh_end_time?: string | null;
  user_id: string,
  wfh_applied_comment: string,
  wfh_status: string,
  wfh_approved_by: string | Date,
  wfh_approved_on: string | Date,
  wfh_approved_comment?: string | null;
  wfh_created_date: string,
  wfh_totalDays: string,
  usr_empID: string;
  user_first_name: string;
  user_last_name: string;
  wfh_modified_status: string;
  status: string;
  limit?: number,
  offset?: number,
  total_records?: number,
  approver_first_name?: string,
  approver_last_name?: string,
  approver_full_name?: string,
  /** Populated on the client for list / dialog display */
  wfh_duration_label?: string,
  wfh_schedule_summary?: string,
}

export interface WfhRequests {
  wfh_id: string,
  lev_type: string,
  wfh_purpose: string,
  wfh_start_date: Date | String,
  wfh_end_date: Date | String,
  /** 1 = full day, 2 = half day */
  wfh_type?: string | number | null,
  wfh_start_time: string | null,
  wfh_end_time: string | null,
  user_id: string,
  wfh_applied_commen: string,
  wfh_status: string,
  wfh_approved_by: string | null,
  wfh_approved_on: string | null,
  wfh_created_date: string,
  wfh_totalDays: string,
  user_first_name: string,
  user_last_name: string,
  request?: string;
}

export interface WfhDetail {
  wfh_id: string,
  lev_type: string,
  wfh_purpose: string,
  wfh_start_date: Date | string,
  wfh_end_date: Date | string,
  /** 1 = full day, 2 = half day */
  wfh_type?: string | number | null;
  wfh_start_time?: string | null;
  wfh_end_time?: string | null;
  user_id: string,
  wfh_applied_comment: string,
  wfh_status: string,
  wfh_approved_by: string | Date,
  wfh_approved_on: string | Date,
  wfh_approved_comment?: string | null;
  wfh_created_date: string,
  wfh_totalDays: string,
  user_first_name: string,
  user_last_name: string,
  usr_empID: string
}

export interface wfhCanceledbyUser {
  wfh_status: string;
  wfh_id: string;
}

export interface ChangeWfhStatus {
  wfh_id: string;
  comments: string;
  wfh_status: string;
}